export default __webpack_public_path__ + "static/media/IconDesc_Extractor.256.f7952654.png";